<template>
  <div class="car-status">
    <div
      class="car-status-checkbox"
      :class="{'car-active': value, 'car-disabled': disabled}"
      @click="setStatus(true)"
      data-js="status--yes"
    >{{$t('workshopRating.takenPlace.yes')}}</div>
    <div
      class="car-status-checkbox"
      :class="{'car-active': !value, 'car-disabled': disabled}"
      @click="setStatus(false)"
      data-js="status--no"
    >{{$t('workshopRating.takenPlace.no')}}</div>
  </div>
</template>

<script>
export default {
  name: 'StatusSwitch',
  props: ['value', 'disabled'],
  methods: {
    setStatus: function (status) {
      if (this.disabled) return;
      this.$emit('input', status);
      this.$emit('change');
    }
  }
}
</script>
